import "./MembershipVehicles.scss";

import { SvgIcon } from "@mui/material";
import ButtonField from "../../Components/Button/ButtonField";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import TableSearch from "../../Components/Table/components/TableSearch";
import { IMembershipVehicleList, MastersProps } from "./IMembershipVehicles";
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { ReactComponent as Add } from "../../Assets/Images/Add.svg";
import { Columns } from "../../Components/Table/ITable";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { getVehicle, getVehicleSearch } from "../../Redux/Slicers/Vehicle/VehicleSlicer";
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { ReactComponent as Edit } from "../../Assets/Images/Edit.svg";
import { ReactComponent as Delete } from "../../Assets/Images/Delete.svg";
import Dialog from "../../Components/Dialog/Dialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { ReactComponent as Cancel } from "../../Assets/Images/Cancel.svg";
import { FormikProps } from "formik";
import {
  clearUpdateVehicleState,
  VehiclesUpdateableData,
} from "../../Redux/Slicers/Vehicle/UpdateVehicleSlicer";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import {
  clearDeleteVehicle,
  deleteVehicle,
} from "../../Redux/Slicers/Vehicle/DeleteVehicleSlice";
import { clearAddVehicleState } from "../../Redux/Slicers/Vehicle/AddVehicleSlicer";
import { OwnerUpdateableData } from '../../Redux/Slicers/Owner/UpdateOwnerSlicer';
import { getMaster } from '../../Redux/Slicers/Master/MasterSlicer';
import { clearDeleteMembershipVehicle, deleteMembershipVehicle } from "../../Redux/Slicers/MembershipVehicle/DeleteMembershipVehicleSlice";
import { clearAddMembershipVehicleState } from "../../Redux/Slicers/MembershipVehicle/AddMembershipVehicleSlicer";
import { clearUpdateMembershipVehicleState, MembershipVehiclesUpdateableData } from "../../Redux/Slicers/MembershipVehicle/UpdateMembershipVehicleSlicer";
import { getMembershipVehicle } from "../../Redux/Slicers/MembershipVehicle/MembershipVehicleSlicer";
import { useParams } from "react-router-dom";
import dayjs from 'dayjs';
import Select from "../../Components/Select/Select";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import { getLocation } from "../../Redux/Slicers/Location/LocationSlicer";

const Vehicle: FunctionComponent<MastersProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.MembershipVehicle);
  const [open, setOpen] = useState<boolean>(false);
  const { id }: any = useParams();
 
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>('');
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<IMembershipVehicleList>>();
  const { data: updateMembershipVehicle, updateableDate } = useAppSelector(
    (state) => state.UpdateMembershipVehicle
  );
  const { data: addMembershipVehicle } = useAppSelector((state) => state.AddMembershipVehicle);
  const { data: deleteMembershipVehicleData } = useAppSelector(
    (state) => state.DeleteMembershipVehicle
  );
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
   const [sortField, setSortField] = useState("created_at");
   const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
   const { data: projectData } = useAppSelector((state) => state?.Location);

   useEffect(() => {
     const key: any = "TN";
     dispatch(getVehicleSearch(key));
   }, []);
   const isUpdateable =
     updateableDate && Object.keys(updateableDate).length !== 0;
   const column: Columns = [
     {
       field: "index",
       renderHeader: () => <b>S.No</b>,
       flex: 1,
       headerAlign: "center",
       align: "center",
       type: "number",
       maxWidth: 90,
       sortable: false,
     },
     {
       field: "location_name",
       renderHeader: () => <b>Location</b>,
       flex: 1,
       type: "string",
       cellClassName: "project_name",
       renderCell: (params) => (params.value ? params.value : "-"),
     },
     {
       field: "user_designation",
       renderHeader: () => <b>Designation</b>,
       flex: 1,
       type: "string",
       cellClassName: "project_name",
       renderCell: (params) => (params.value ? params.value : "-"),
     },
     {
       field: "first_name",
       renderHeader: () => <b>User Name</b>,
       flex: 1,
       type: "string",
       cellClassName: "project_name",
       renderCell: (params) => (params.value ? params.value : "-"),
     },
     {
       field: "date",
       renderHeader: () => <b>Date</b>,
       flex: 1,
       type: "string",
       cellClassName: "project_name",
       renderCell: (params) => {
         if (!params.value) return "-";
         try {
           // Format as DD-MMM-YYYY with month in uppercase
           return dayjs(params.value)
             .format("DD-MMM-YYYY")
             .replace(/[a-z]/g, (letter) => letter.toUpperCase());
         } catch (error) {
           return params.value;
         }
       },
     },
     {
       field: "vehicle_plate_no",
       renderHeader: () => <b>vehicle no</b>,
       flex: 1,
       type: "string",
       cellClassName: "project_name",
     },
     {
       field: "vehicle_type",
       renderHeader: () => <b>vehicle type</b>,
       flex: 1,
       type: "string",
       cellClassName: "vehicle_type",
       renderCell: (params) => (params.value ? params.value : "-"),
     },
     {
       field: "RFID",
       renderHeader: () => <b>RFID</b>,
       flex: 1,
       type: "string",
       cellClassName: "tower_name",
     },

     // {
     //   field: 'phone',
     //   renderHeader: () => <b>Contact Number</b>,
     //   flex: 1,
     //   type: 'string',
     //   cellClassName: 'tower_name',
     // },

     {
       field: "registration_name",
       renderHeader: () => <b>Registration name</b>,
       flex: 1,
       align: "left",
       type: "string",
     },

     // {
     //   field: "is_accept",
     //   renderHeader: () => <b>Accept</b>,
     //   flex: 1,
     //   type: "boolean",
     //   maxWidth: 190,

     //   renderCell: (params) => (
     //     <div>{params.value ? "Accepted" : "Pending"}</div>
     //   ),
     //   cellClassName: (params) => (params.value ? "active" : "inactive"),
     // },
     // {
     //   field: "action",
     //   renderHeader: () => <b>Action</b>,
     //   flex: 1,
     //   type: "actions",
     //   getActions: (params: GridRowParams<any>) => [
     //     // <GridActionsCellItem
     //     //   key="Edit"
     //     //   label="Edit"
     //     //   icon={<Edit className="action_icons" />}
     //     //   onClick={() => {
     //     //     // console.log(params.row);
     //     //     // dispatch(getTower(params.row.projectId));
     //     //     // dispatch(selectUpdatehandoverSchedule(params.row.id));
     //     //     // dispatch(towersUpdateableData(params.row));
     //     //     dispatch(MembershipVehiclesUpdateableData(params.row));
     //     //     setOpen(true);
     //     //   }}
     //     // />,
     //     <GridActionsCellItem
     //       key="Delete"
     //       label="Delete"
     //       icon={<Delete className="action_icons" />}
     //       onClick={() => {
     //         setDeleteOpen(true);
     //         setDeleteableName(params.row.name ?? "");
     //         setDeleteableId(params.row.id!);
     //       }}
     //     />,
     //   ],
     //   cellClassName: "action_cell",
     // },
   ];

   useEffect(() => {
     // dispatch(getMembershipVehicle({ key: "member" }));
     dispatch(getMaster(null));
     dispatch(getLocation());
   }, [
     updateMembershipVehicle,
     addMembershipVehicle,
     deleteMembershipVehicleData,
   ]);

   useEffect(() => {
     return () => {
       dispatch(clearAddMembershipVehicleState());
       dispatch(clearUpdateMembershipVehicleState());
       dispatch(clearDeleteMembershipVehicle());
     };
   }, []);

   const data1 = data?.response?.data;
   const VehicleData = Array.isArray(data1)
     ? data1.map((Vehicle: any, index) => ({
         ...Vehicle,
         id: Vehicle._id,
         index: page * pageSize + (index + 1), // ✅ fixed serial number
         location_name: Vehicle?.location_id?.location_name,
         first_name: Vehicle?.user_id?.first_name,
         vehicle_plate_no: Vehicle?.vehicle_id?.vehicle_plate_no,
         vehicle_type: Vehicle?.vehicle_id?.vehicle_type,
         RFID: Vehicle?.vehicle_id?.RFID,
         registration_name: Vehicle?.vehicle_id?.registration_name,
         phone: Vehicle?.phone,
         date: Vehicle?.date,
         user_designation: Vehicle?.user_designation_id?.name,
       }))
     : [];

   const vehicleForm = (data: FormikProps<IMembershipVehicleList>) => {
     setFormik(data);
   };

   const locationData = projectData?.response?.data;

   const projects = Array.isArray(locationData)
     ? locationData.map((project) => ({
         label: project.location_name,
         value: project._id!,
       }))
     : [];
   useEffect(() => {
     dispatch(
       getMembershipVehicle({
         page,
         pageSize,
         key: "member",
         sortField,
         sortOrder,
       })
     ); // 🔑 pass to backend
   }, [page, pageSize, dispatch, sortField, sortOrder]);

   return (
     <>
       <Table
         rows={VehicleData ?? []}
         columns={column}
         rowCount={(data?.response as any)?.total ?? 0}
         onPageChange={(newPage, newPageSize) => {
           setPage(newPage);
           setPageSize(newPageSize);
         }}
         onSortChange={(field, order) => {
           if (field && order) {
             setSortField(field);
             setSortOrder(order);
           }
         }}>
         <CustomToolbar>
           <h6>Membership Vehicle</h6>

           <Select
             id="locationId"
             name="locationId"
             className="project_name"
             placeholder="Location Name"
             shrink={false}
             size="small"
             options={projects}
             onChange={(_, value: any) => {
               if (value) {
                 const projectValue: any = value as AutocompleteOption;
                 const values = {
                   locationId: projectValue?.value,
                   key: "member",
                 };
                 console.log(projectValue?.value);
                 dispatch(
                   getMembershipVehicle({
                     page: 0,
                     pageSize,
                     locationId: values?.locationId,
                     key: values.key,
                   })
                 );
               } else {
                 dispatch(
                   getMembershipVehicle({ page: 0, pageSize, key: "member" })
                 );
               }
             }}
           />
           <TableSearch />
           <ButtonField
             className="add_button"
             onClick={() => setOpen(true)}>
             <SvgIcon
               component={Add}
               inheritViewBox
             />
             Add New
           </ButtonField>
         </CustomToolbar>
       </Table>

       <Dialog
         open={open}
         dialogClassName="master_dialog"
         dialogTitleClassName="master_dialog_title"
         Dialog_Title={
           <>
             {isUpdateable
               ? "Edit Membership Vehicle"
               : "Add Membership Vehicle"}
             <IconButtonField onClick={() => setOpen(false)}>
               <SvgIcon
                 component={Cancel}
                 inheritViewBox
               />
             </IconButtonField>
           </>
         }
         // Dialog_Content={<VehicleForm vehicleForm={vehicleForm} />}
         dialogActionClassName="master_dialog_action"
         Dialog_Actions={
           <>
             <ButtonField
               className="cancel_button"
               onClick={() => setOpen(false)}>
               Cancel
             </ButtonField>
             <ButtonField
               className="add_button"
               onClick={() => formik?.handleSubmit()}>
               {isUpdateable ? "Update" : "Save"}
             </ButtonField>
           </>
         }
       />

       <ResponseDialog
         response={addMembershipVehicle}
         parentDialog={setOpen}
       />
       <ResponseDialog
         response={updateMembershipVehicle}
         parentDialog={setOpen}
       />

       <DeleteDialog
         deleteableName={deleteableName}
         open={deleteOpen}
         setOpen={setDeleteOpen}
         deleteFunction={() => dispatch(deleteMembershipVehicle(deleteableId))}
         response={deleteMembershipVehicleData}
         deleteContent="Are you sure you want to move cancel membership"
       />
     </>
   );
};

export default Vehicle;
